export default __webpack_public_path__ + "static/media/JannaGoliff_headshot.d174847f.JPG";